import {fetchDeliveryWindowConfigDetails, setConfiguration} from "../network/InductManagementNetworkAPI";
import {getWindowString} from "../Utils";
import {DEFAULT_ALERT, DWC_ACTIONS} from "../Constants";
import cloneDeep from "lodash/cloneDeep";

export const DeliveryWindowConfigReducer = (state, action) => {
    switch (action.type) {
        case DWC_ACTIONS.LOAD_VIEW:
            fetchDeliveryWindowConfigDetails(action.data.dispatcher)
            return state
        case DWC_ACTIONS.SAVE_CONFIG:
            setConfiguration(state.packageCycleConfig, action.data.dispatch)
            return state
        case DWC_ACTIONS.ADD_CYCLE:
            const addCycleConfig =
                addCycle(cloneDeep(state.packageCycleConfig), action.data.windowString, action.data.cycleName)
            return {...state, packageCycleConfig: addCycleConfig}
        case DWC_ACTIONS.REMOVE_CYCLE:
            const removeCycleConfig =
                removeCycle(cloneDeep(state.packageCycleConfig), action.data.windowString, action.data.cycleName)
            return {...state, packageCycleConfig: removeCycleConfig}
        case DWC_ACTIONS.ADD_WINDOW:
            const addWindowConfig = addWindow(cloneDeep(state.packageCycleConfig), action.data.window)
            return {...state, ...addWindowConfig}
        case DWC_ACTIONS.REMOVE_WINDOW:
            const removeWindowConfig = removeWindow(cloneDeep(state.packageCycleConfig), action.data.windowString)
            return {...state, ...removeWindowConfig}
        case DWC_ACTIONS.RECEIVE_DATA:
            return {...state, ...action.data}
        case DWC_ACTIONS.SET_VALUE:
            return {...state, ...action.data}
        case DWC_ACTIONS.SET_ALERT:
            return {...state, alert: action.data}
        case DWC_ACTIONS.CLEAR_ALERT:
            return {...state, alert: DEFAULT_ALERT}
        case DWC_ACTIONS.EDIT_ACCESS:
            return {...state, isEditable: action.data}
        default:
            return state
    }
}

const addCycle = (config, windowString, cycleName) => {
    const addCycleConfig = config
    if (windowString in addCycleConfig) {
        addCycleConfig[windowString].cycleList.push(cycleName)
    }
    return addCycleConfig
}

const removeCycle = (config, windowString, cycleName) => {
    const removeCycleConfig = config
    if (windowString in removeCycleConfig) {
        let index = removeCycleConfig[windowString].cycleList.indexOf(cycleName)
        removeCycleConfig[windowString].cycleList.splice(index, 1)
    }
    return removeCycleConfig
}

const addWindow = (config, window) => {
    const windowString = getWindowString(window)
    return {
        packageCycleConfig: {
            ...config,
            [windowString]: {window: window, cycleList: []}
        }
    }
}

const removeWindow = (config, windowString) => {
    const removeWindowConfig = {packageCycleConfig: {...config}}
    delete removeWindowConfig.packageCycleConfig[windowString]
    return removeWindowConfig
}


// WEBPACK FOOTER //
// ./src/components/inductmanagementv2/reducer/DeliveryWindowConfigReducer.js